@let origin = originSg();

<atn-ds-attached-overlay
  [origin]="origin"
  [connectedPositions]="[
    {
      originX: 'center',
      originY: 'center',
      overlayX: 'center',
      overlayY: 'bottom',
      offsetY: -deadZoneRadius,
    },
    {
      originX: 'center',
      originY: 'center',
      overlayX: 'center',
      overlayY: 'top',
      offsetY: deadZoneRadius,
    },
    {
      originX: 'center',
      originY: 'center',
      overlayX: 'end',
      overlayY: 'center',
      offsetX: -deadZoneRadius,
    },
    {
      originX: 'center',
      originY: 'center',
      overlayX: 'start',
      overlayY: 'center',
      offsetX: deadZoneRadius,
    },
  ]"
>
  <div class="atn-summit-allocation-graph-base-overlay">
    <ng-content />
  </div>
</atn-ds-attached-overlay>
